<template>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Informasi Koin</h5>
      <div class="row">
        <p class="col text-light">Kami mendukung deposit melalui:</p>

        <!-- info token -->
        <div class="col-md-12 text-light">
          <table class="table table-striped">
            <thead>
              <tr>
                <th></th>
                <th class="text-left">Chain Name</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>-</td>
                <td>Ethereum MainNet</td>
              </tr>
              <tr>
                <td>-</td>
                <td>Arbitrum One Mainnet</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// node_modules
import Cookies from "js-cookie";

// applibs
import themain from "@/applibs/themain.js";
import thestore from "@/applibs/thestore.js";

// components

export default {
  components: {},
  props: {
    activeCurrencyObj: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      themain,
      token: Cookies.get("jwt") || Cookies.get("usid"),
      usid: Cookies.get("usid"),
      evm_tokens: [],
    };
  },

  async mounted() {
    var self = this;

    self.getEvmTokens();
  },

  methods: {
    async getEvmTokens() {
      var self = this;
      var res = await thestore.getEvmTokensByCcurrencyId(
        self.activeCurrencyObj.id
      );
      self.evm_tokens = res.filter((token) => token.tracking); // Filter hanya tampilkan yang tracking = true
    },
  },
};
</script>
